// Intialise push notifications if right page
$( document ).on("turbo:load", initPushNotifications);

// Main logic
function initPushNotifications() {

  if($(".admin-new-push-notification").length) {
    var appLatLng, appRadius;

    $('#map').locationpicker({
      radius: parseInt($(".modal-radius").val()) || 1000,
      zoom: 10,
      inputBinding: {
        latitudeInput: $('.modal-latitude'),
        longitudeInput: $('.modal-longitude'),
        radiusInput: $('.modal-radius'),
        locationNameInput: $('.modal-search')
      },
      enableAutocomplete: true,
      onchanged: function (currentLocation, radius, isMarkerDropped) {
        if (radius == appRadius) {
          $(".modal-location").val('')
        }
      }
    });

    // Initialise Google Maps
    function initGoogleMap(appId) {
      $(".latitude, .longitude, .radius").val("");
      $.getJSON("/admin/push_notifications/apps/" + appId + ".json", function(json) {
        appLatLng = { latitude: parseFloat(json.lat), longitude: parseFloat(json.lon) };

        $("#map-modal").on('shown.bs.modal', function () {
          var lat = parseFloat($(".latitude").val()),
            lot = parseFloat($(".longitude").val()),
            radius = parseInt($(".radius").val());
          if (lat && lot && radius) {
            $('#map').locationpicker("location", { latitude: lat, longitude: lot, radius: radius });
          } else {
            $('#map').locationpicker("location", appLatLng);
          }
          $('#map').locationpicker("autosize");
        });

        $("#location-save").on('click', function () {
          $(".latitude").val($(".modal-latitude").val());
          $(".longitude").val($(".modal-longitude").val());
          $(".radius").val($(".modal-radius").val());
        });

        $(".modal-latitude, .modal-longitude, .modal-search").on('change', function () {
          appRadius = $(".modal-radius").val()
        });

        $(" .latitude, .longitude").on('change', function () {
          $(".modal-location").val('')
        });

        if (json.standalone === true) {
          $(".app-type-checkboxes").show();
          $(".situate-app-checkbox").show();
          $(".standalone-app-checkbox").show();
        } else {
          $(".app-type-checkboxes").show();
          $(".situate-app-checkbox").show();
          $(".standalone-app-checkbox").hide();
        }
      });
    }

    // Hide all dependent fields
    function hideDependentFields() {
      $(".standalone-form-group").hide();
      $(".app-type-checkboxes").hide();
      $(".global-channel-form-group").hide();
      $(".action-form-group").hide();
      $(".variant-id-form-group").hide();
      $(".node-content-id-form-group").hide();
      $(".app-store-id-form-group").hide();
      $(".play-store-id-form-group").hide();
      $(".targets-form-group").hide();
    }

    // Hide or show app store and play store field groups
    function setStoreFields(display) {
      if(display === false) {
        $(".app-store-id-form-group").hide();
        $(".play-store-id-form-group").hide();
      } else {
        $(".app-store-id-form-group").show();
        $(".play-store-id-form-group").show();
      }
    }

    // Initially hide dependent fields and global channel fields
    hideDependentFields();
    $("#push-notification-global").hide();

    // If global channel
    $("#new_push_notification").on("change", "#push_notification_global_channel", function(ev) {
      if($(this).is(':checked')) {
        $("#push_notification_standalone").val("");
        $("#push_notification_standalone").trigger("change");
        $("#push-notification-non-global").hide();
        $("#push-notification-global").show();
        hideDependentFields();
        $(".standalone-form-group").show();
      }
      else {
        $("#push_notification_app_id").val("");
        $("#push_notification_app_id").trigger("change");
        $("#push-notification-non-global").show();
        $("#push-notification-global").hide();
        $(".standalone-form-group").hide();
        hideDependentFields();
        $(".app-id-form-group").show();
      }
    });

    // If standalone app is selected, show actions and target options
    $("#new_push_notification").on("change", "#push_notification_standalone", function(ev) {
      var appId = $("#push_notification_standalone option:selected").val();
      if (appId) {
        $.getJSON("/admin/push_notifications/variants/" + appId + ".json", function(json) {
          $("#push_notification_variant_id").empty();
          $("#push_notification_variant_id").append('<option value="">Select a variant...</option>');
          $.each(json.variants, function(key, value) {
            $("#push_notification_variant_id").append('<option value="' + value.id + '">' + value.name + '</option>');
          });
        });

        initGoogleMap(appId);

        $.get("/admin/push_notifications/gps_points/" + appId + "/true" , function(json) {
          $("#target_location_id").empty();
          $("#target_location_id").append('<option value="">Please select</option>');
          $.each(json.gps_points, function(key, value) {
            $("#target_location_id").append('<option value="' + value.id + '">' + value.name + '</option>');
          });
        });

        $(".targets-form-group").show();
        $(".variant-id-form-group").show();
      } else {
        setStoreFields(false);
        $(".targets-form-group").hide();
        $(".variant-id-form-group").hide();
      }

      $("#push_notification_variant_id").val("");
      $("#push_notification_variant_id").trigger("change");
      $("#push_notification_node_content_id").val("");
      $("#push_notification_node_content_id").trigger("change");
    });

    // If app is selected, populate the variant list
    $("#new_push_notification").on("change", "#push_notification_app_id", function(ev) {
      var appId = $("#push_notification_app_id option:selected").val();
      if (appId) {
        $.getJSON("/admin/push_notifications/variants/" + appId + ".json", function(json) {
          $("#push_notification_variant_id").empty();
          $("#push_notification_variant_id").append('<option value="">Select a variant...</option>');
          $.each(json.variants, function(key, value) {
            $("#push_notification_variant_id").append('<option value="' + value.id + '">' + value.name + '</option>');
          });
        });

        initGoogleMap(appId);

        $(".variant-id-form-group").show();
      } else {
        $(".variant-id-form-group").hide();
      }
      $(".app-type-checkboxes").hide();
      $("#push_notification_standalone_app").prop('checked', false);
      $("#push_notification_variant_id").val("");
      $("#push_notification_variant_id").trigger("change");
      $("#push_notification_node_content_id").val("");
      $("#push_notification_node_content_id").trigger("change");
    });

    // Clear and populate node list on variant change
    $("#new_push_notification").on("change", "#push_notification_variant_id", function(ev) {
      var variantId = $("#push_notification_variant_id option:selected").val();
      if (variantId) {
        $.get("/admin/push_notifications/nodes/" + variantId, function(data) {
          $("#push_notification_node_content_id").empty();
          $("#push_notification_node_content_id").append('<option value="">Select a node or content item...</option>');
          $("#push_notification_node_content_id").append(data);
        });
        $.get("/admin/push_notifications/gps_points/" + variantId + "/false", function(json) {
          $("#target_location_id").empty();
          $("#target_location_id").append('<option value="">Please select</option>');
          $.each(json.gps_points, function(key, value) {
            $("#target_location_id").append('<option value="' + value.id + '">' + value.name + '</option>');
          });
        });
        $(".action-form-group").show();
        $(".targets-form-group").show();
      } else {
        setStoreFields(false);
        $(".action-form-group").hide();
        $(".targets-form-group").hide();
        $(".node-content-id-form-group").hide();
      }
      $("#push_notification_node_content_id").val("");
      $("#push_notification_node_content_id").trigger("change");
      $("#push_notification_action").val("");
      $("#push_notification_action").trigger("change");
    });

    // Show / hide fields based on action chosen
    $("#new_push_notification").on("change", "#push_notification_action", function(ev) {
      $("#push_notification_node_content_id").val("");
      $("#push_notification_node_content_id").trigger("change");
      switch($("#push_notification_action").val()) {
        case "show_node_content":
          $(".node-content-id-form-group").show();
          setStoreFields(false);
          break;
        case "promote_apps":
          setStoreFields(true);
          $(".node-content-id-form-group").hide();
          break;
        case "simple_message":
          setStoreFields(false);
          $(".node-content-id-form-group").hide();
          break;
        case "show_app_variant_list":
          setStoreFields(false);
          $(".node-content-id-form-group").hide();
          break;
        default:
          $(".node-content-id-form-group").hide();
          setStoreFields(false);
      }
    });

    // If a GPS point is selected, show it on the map
    $("#new_push_notification").on("change", "#target_location_id", function(ev) {
      var gpsId = $("#target_location_id :checked").val();

      if (gpsId) {
        $.getJSON("/admin/push_notifications/gps_point/" + gpsId + ".json", function(json) {
          myLatLng = { latitude: parseFloat(json.lat), longitude: parseFloat(json.lon) };
        }).done(function() {
          $('#map').locationpicker("location", myLatLng)
        })
      } else {
        $('#map').locationpicker("location", appLatLng)
      }
    });
  }
}
